import { WorkOrder as VbsWorkOrder } from "@/services/backend/vbs/work-orders/types/work-order";
import { useEffect } from "react";
import { useVbsTreatmentShowQuery } from "@/services/backend/vbs/treatments/api/treatment-api";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { formatDate } from "@/shared/lib/utilities/date";
import {
  ConnectInvoiceExportDialog,
  useSetConnectInvoiceExportText,
} from "@/services/backend/connect/components/connect-invoice-export";
import {
  useVbsPricing,
  useVbsSegmentPrices,
} from "@/services/backend/connect/components/string-builder-helpers-vbs";
import {
  useAttachmentsString,
  useServiceKindTitle,
  useWorkOrderReference,
} from "@/services/backend/connect/components/string-builder-helpers";

export function ConnectInvoiceExportDialogVbs({
  workOrder,
}: {
  workOrder: VbsWorkOrder;
}) {
  return (
    <ConnectInvoiceExportDialog>
      <VbsInvoiceExport workOrder={workOrder} />
    </ConnectInvoiceExportDialog>
  );
}

export function VbsInvoiceExport({ workOrder }: { workOrder: VbsWorkOrder }) {
  const setText = useSetConnectInvoiceExportText();
  const { data: treatment } = useVbsTreatmentShowQuery({
    id: workOrder.treatmentId,
  });

  const title = useServiceKindTitle(GSMServiceKind.VBS);
  const workOrderReference = useWorkOrderReference(
    workOrder,
    GSMServiceKind.VBS,
  );
  const segmentPrices = useVbsSegmentPrices(treatment);
  const pricing = useVbsPricing(workOrder.pricingId);
  const attachments = useAttachmentsString();

  const { beginDate } = workOrder;

  useEffect(() => {
    setText(
      [
        title,
        "",
        workOrderReference,
        `Leistungszeitpunkt: ${formatDate(beginDate)}`,
        "",
        segmentPrices,
        pricing,
        "",
        attachments,
      ].join("\n"),
    );
  }, [
    setText,
    title,
    workOrderReference,
    beginDate,
    segmentPrices,
    pricing,
    attachments,
  ]);

  return null;
}
